import messages from '~/constants/localizations/teamStats';

const MLB_BATTING = [
  {
    key: 'batting_average',
    label: 'AVG',
    localized_label: messages.baseball.batting_average,
  },
  {
    key: 'on_base_percentage',
    label: 'OBP',
    localized_label: messages.baseball.on_base_percentage,
  },
  {
    key: 'slugging_percentage',
    label: 'SLG',
    localized_label: messages.baseball.slugging_percentage,
  },
  {
    key: 'on_base_plus_slugging',
    label: 'OPS',
    localized_label: messages.baseball.slugging_percentage,
  },
  {
    key: 'home_runs',
    label: 'HR',
    localized_label: messages.baseball.home_runs,
  },
  {
    key: 'stolen_bases',
    label: 'SB',
    localized_label: messages.baseball.stolen_bases,
  },
];

const MLB_PITCHING = [
  {
    key: 'earned_run_average',
    label: 'ERA',
    localized_label: messages.baseball.earned_run_average,
  },
  {
    key: 'walks_plus_hits_per_inning_pitched',
    label: 'WHIP',
    localized_label: messages.baseball.walks_plus_hits_per_inning_pitched,
  },
  {
    key: 'strikeouts_per_9_innings_pitched',
    label: 'K/9',
    localized_label: messages.baseball.strikeouts_per_9_innings_pitched,
  },
  {
    key: 'home_runs',
    label: 'HR',
    localized_label: messages.baseball.home_runs,
  },
  {
    key: 'fielding_percentage',
    label: 'FLD%',
    localized_label: messages.baseball.fielding_percentage,
  },
  {
    key: 'batting_average_against',
    label: 'BAA',
    localized_label: messages.baseball.batting_average_against,
  },
];

const MLB_OVERVIEW = [
  {
    key: 'runs_per_game',
    label: 'Runs',
    localized_label: messages.baseball.runs_per_game,
  },
  {
    key: 'runs_against_per_game',
    label: 'Runs Allowed',
    localized_label: messages.baseball.runs_against_per_game,
  },
  {
    key: 'hits_per_game',
    label: 'Hits',
    localized_label: messages.baseball.hits_per_game,
  },
  {
    key: 'hits_against_per_game',
    label: 'Hits Allowed',
    localized_label: messages.baseball.hits_against_per_game,
  },
];

const NBA_PREGAME = [
  {
    key: 'pace',
    label: 'Pace',
    localized_label: messages.basketball.pace,
  },
  {
    key: 'field_goals_percentage',
    label: 'FG (%)',
    percentage: true,
    localized_label: messages.basketball.field_goals_percentage,
  },
  {
    key: 'three_point_field_goals_made_average',
    label: '3PT FG',
    localized_label: messages.basketball.three_point_field_goals_made_average,
  },
  {
    key: 'three_point_field_goals_percentage',
    label: '3PT FG (%)',
    percentage: true,
    localized_label: messages.basketball.three_point_field_goals_percentage,
  },
  {
    key: 'free_throws_percentage',
    label: 'FT (%)',
    percentage: true,
    localized_label: messages.basketball.free_throws_percentage,
  },
  {
    key: 'rebounds_total_average',
    label: 'Rebounds',
    localized_label: messages.basketball.rebounds_total_average,
  },
  {
    key: 'rebounds_offensive_average',
    label: 'Offensive Rebounds',
    localized_label: messages.basketball.rebounds_offensive_average,
  },
  {
    key: 'assists_average',
    label: 'Assists',
    localized_label: messages.basketball.assists_average,
  },
  {
    key: 'assist_rate',
    label: 'Assist (%)',
    percentage: true,
    localized_label: messages.basketball.assist_rate,
  },
  {
    key: 'steals_average',
    label: 'Steals',
    localized_label: messages.basketball.steals_average,
  },
  {
    key: 'turnovers_average',
    label: 'Turnovers',
    localized_label: messages.basketball.turnovers,
  },
  {
    key: 'true_shooting_percentage',
    label: 'True Shooting (%)',
    percentage: true,
    localized_label: messages.basketball.true_shooting_percentage,
  },
  {
    key: 'effective_field_goal_percentage',
    label: 'Effective Field Goal (%)',
    percentage: true,
    localized_label: messages.basketball.effective_field_goal_percentage,
  },
  {
    key: 'offensive_rating',
    label: 'Offensive Rating',
    localized_label: messages.basketball.offensive_rating,
  },
  {
    key: 'defensive_rating',
    label: 'Defensive Rating',
    localized_label: messages.basketball.defensive_rating,
  },
  {
    key: 'pythagorean_wins',
    label: 'Pythagorean Wins',
    localized_label: messages.basketball.pythagorean_wins,
  },
];

const WNBA_PREGAME = [
  {
    key: 'field_goals_percentage',
    label: 'FG (%)',
    percentage: true,
    localized_label: messages.basketball.field_goals_percentage,
  },
  {
    key: 'three_point_field_goals_made_average',
    label: '3PT FG',
    localized_label: messages.basketball.three_point_field_goals_made_average,
  },
  {
    key: 'three_point_field_goals_percentage',
    label: '3PT FG (%)',
    percentage: true,
    localized_label: messages.basketball.three_point_field_goals_percentage,
  },
  {
    key: 'free_throws_percentage',
    label: 'FT (%)',
    percentage: true,
    localized_label: messages.basketball.free_throws_percentage,
  },
  {
    key: 'rebounds_total_average',
    label: 'Rebounds',
    localized_label: messages.basketball.rebounds_total_average,
  },
  {
    key: 'rebounds_offensive_average',
    label: 'Offensive Rebounds',
    localized_label: messages.basketball.rebounds_offensive_average,
  },
  {
    key: 'assists_average',
    label: 'Assists',
    localized_label: messages.basketball.assists_average,
  },
  {
    key: 'steals_average',
    label: 'Steals',
    localized_label: messages.basketball.steals_average,
  },
  {
    key: 'turnovers_average',
    label: 'Turnovers',
    localized_label: messages.basketball.turnovers,
  },
];

const NBA = [
  {
    key: 'field_goals_percentage',
    label: 'Field Goals',
    percentage: true,
    numerator_key: 'field_goals_made',
    denominator_key: 'field_goals_attempted',
    localized_label: messages.basketball.field_goals_percentage,
  },
  {
    key: 'three_point_field_goals_percentage',
    label: '3 Pointers',
    percentage: true,
    numerator_key: 'three_point_field_goals_made',
    denominator_key: 'three_point_field_goals_attempted',
    localized_label: messages.basketball.three_point_field_goals_percentage,
  },
  {
    key: 'free_throws_percentage',
    label: 'Free Throws',
    percentage: true,
    numerator_key: 'free_throws_made',
    denominator_key: 'free_throws_attempted',
    localized_label: messages.basketball.free_throws_percentage,
  },
  {
    key: 'rebounds_total',
    label: 'Rebounds',
    localized_label: messages.basketball.rebounds_total,
  },
  {
    key: 'rebounds_offensive',
    label: 'Offensive Rebounds',
    localized_label: messages.basketball.rebounds_offensive,
  },
  {
    key: 'assists',
    label: 'Assists',
    localized_label: messages.basketball.assists,
  },
  {
    key: 'steals',
    label: 'Steals',
    localized_label: messages.basketball.steals,
  },
  {
    key: 'blocked_shots',
    label: 'Blocks',
    localized_label: messages.basketball.blocked_shots,
  },
  {
    key: 'turnovers',
    label: 'Turnovers',
    localized_label: messages.basketball.turnovers,
  },
  {
    key: 'personal_fouls',
    label: 'Fouls (pers)',
    localized_label: messages.basketball.personal_fouls,
  },
];

const WNBA = [
  {
    key: 'field_goals_percentage',
    label: 'Field Goals',
    percentage: true,
    numerator_key: 'field_goals_made',
    denominator_key: 'field_goals_attempted',
    localized_label: messages.basketball.field_goals_percentage,
  },
  {
    key: 'three_point_field_goals_percentage',
    label: '3 Pointers',
    percentage: true,
    numerator_key: 'three_point_field_goals_made',
    denominator_key: 'three_point_field_goals_attempted',
    localized_label: messages.basketball.three_point_field_goals_percentage,
  },
  {
    key: 'free_throws_percentage',
    label: 'Free Throws',
    percentage: true,
    numerator_key: 'free_throws_made',
    denominator_key: 'free_throws_attempted',
    localized_label: messages.basketball.free_throws_percentage,
  },
  {
    key: 'rebounds_total',
    label: 'Rebounds',
    localized_label: messages.basketball.rebounds_total,
  },
  {
    key: 'rebounds_offensive',
    label: 'Offensive Rebounds',
    localized_label: messages.basketball.rebounds_offensive,
  },
  {
    key: 'assists',
    label: 'Assists',
    localized_label: messages.basketball.assists,
  },
  {
    key: 'steals',
    label: 'Steals',
    localized_label: messages.basketball.steals,
  },
  {
    key: 'blocked_shots',
    label: 'Blocks',
    localized_label: messages.basketball.blocked_shots,
  },
  {
    key: 'turnovers',
    label: 'Turnovers',
    localized_label: messages.basketball.turnovers,
  },
  {
    key: 'personal_fouls',
    label: 'Fouls (pers)',
    localized_label: messages.basketball.personal_fouls,
  },
];

const SOCCER = [
  {
    key: 'formation',
    label: 'Formation',
    localized_label: messages.soccer.formation,
  },
  {
    key: 'ball_possession',
    label: 'Possession',
    localized_label: messages.soccer.ball_possession,
    percentage: true,
  },
  {
    key: 'shots_on_goal',
    label: 'Shots (on goal)',
    localized_label: messages.soccer.shots_on_goal,
  },
  {
    key: 'corner_kicks',
    label: 'Corner Kicks',
    localized_label: messages.soccer.corner_kicks,
  },
  {
    key: 'crosses',
    label: 'Crosses',
    localized_label: messages.soccer.crosses,
  },
  {
    key: 'fouls',
    label: 'Fouls',
    localized_label: messages.soccer.fouls,
  },
  {
    key: 'yellow_cards',
    label: 'Yellow Cards',
    localized_label: messages.soccer.yellow_cards,
  },
  {
    key: 'red_cards',
    label: 'Red Cards',
    localized_label: messages.soccer.red_cards,
  },
  {
    key: 'offsides',
    label: 'Offsides',
    localized_label: messages.soccer.offsides,
  },
  {
    key: 'assists',
    label: 'Assists',
    localized_label: messages.soccer.assists,
  },
];

const NHL_PREGAME_OFFENSIVE = [
  {
    key: 'goals_per_game',
    label: 'Goals',
    localized_label: messages.baseball.goals_per_game,
  },
  {
    key: 'shots_on_goal_per_game',
    label: 'Shots On Goal',
    localized_label: messages.baseball.shots_on_goal_per_game,
  },
  {
    key: 'power_play_percentage',
    label: 'Power Play (%)',
    localized_label: messages.baseball.power_play_percentage,
  },
  {
    key: 'faceoff_win_percentage',
    label: 'Faceoffs (%)',
    localized_label: messages.baseball.faceoff_win_percentage,
  },
  {
    key: 'team_shooting_percentage',
    label: 'Shooting (%)',
    localized_label: messages.baseball.team_shooting_percentage,
  },
];

const NHL_PREGAME_DEFENSIVE = [
  {
    key: 'goals_allowed_per_game',
    label: 'Goals Allowed',
    localized_label: messages.baseball.goals_allowed_per_game,
  },
  {
    key: 'shots_on_goal_allowed_per_game',
    label: 'SOG Allowed',
    localized_label: messages.baseball.shots_on_goal_allowed_per_game,
  },
  {
    key: 'penalty_minutes_per_game',
    label: 'Penalty Minutes',
    localized_label: messages.baseball.penalty_minutes_per_game,
  },
  {
    key: 'penalty_kill_percentage',
    label: 'Penalty Kill (%)',
    localized_label: messages.baseball.penalty_kill_percentage,
  },
];

const NHL = [
  {
    key: 'faceoff_winning_percentage',
    label: 'Faceoffs (%)',
    localized_label: messages.baseball.faceoff_winning_percentage,
  },
  {
    key: 'power_play_opportunities',
    label: 'Power Plays',
    localized_label: messages.baseball.power_play_opportunities,
  },
  {
    key: 'hits',
    label: 'Hits',
    localized_label: messages.baseball.hits,
  },
  {
    key: 'shots',
    label: 'Shots on Goal',
    localized_label: messages.baseball.shots,
  },
];

const NFL_PREGAME_OFFENSIVE = [
  {
    key: 'yards_per_game',
    label: 'Total Yards',
    localized_label: messages.football.yards_per_game,
  },
  {
    key: 'passing_yards_per_game',
    label: 'Passing Yards',
    localized_label: messages.football.passing_yards_per_game,
  },
  {
    key: 'rushing_yards_per_game',
    label: 'Rushing Yards',
    localized_label: messages.football.rushing_yards_per_game,
  },
  {
    key: 'points_per_game',
    label: 'Points',
    localized_label: messages.football.points_per_game,
  },
  {
    key: 'third_downs_percentage',
    label: '3rd Downs %',
    localized_label: messages.football.third_downs_percentage,
  },
];

const NFL_PREGAME_DEFENSIVE = [
  {
    key: 'defensive_yards_per_game',
    label: 'Total Yards',
    localized_label: messages.football.yards_per_game,
  },
  {
    key: 'defensive_passing_yards_per_game',
    label: 'Passing Yards',
    localized_label: messages.football.passing_yards_per_game,
  },
  {
    key: 'defensive_rushing_yards_per_game',
    label: 'Rushing Yards',
    localized_label: messages.football.rushing_yards_per_game,
  },
  {
    key: 'defensive_points_per_game',
    label: 'Points',
    localized_label: messages.football.points_per_game,
  },
  {
    key: 'defensive_third_downs_percentage',
    label: '3rd Downs %',
    localized_label: messages.football.third_downs_percentage,
  },
];

const NFL = [
  {
    key: 'first_downs_number',
    label: 'First Downs',
    localized_label: messages.football.first_downs,
  },
  {
    key: 'third_down_percent',
    label: '3rd Down Efficiency',
    localized_label: messages.football.third_downs_efficiency,
  },
  {
    key: 'fourth_down_percent',
    label: '4th Down Efficiency',
    localized_label: messages.football.fourth_downs_efficiency,
  },
  {
    key: 'rushing_yards',
    label: 'Rushing Yards',
    localized_label: messages.football.rushing_yards_per_game,
  },
  {
    key: 'passing_net_yards',
    label: 'Passing Yards',
    localized_label: messages.football.passing_yards_per_game,
  },
  {
    key: 'net_yards',
    label: 'Total Yards',
    localized_label: messages.football.yards_per_game,
  },
  {
    key: 'sack_yards',
    label: 'Sacks (Yards)',
    localized_label: messages.football.sack_yards,
  },
  {
    key: 'passing_interceptions',
    label: 'Interceptions Thrown',
    localized_label: messages.football.interceptions_thrown,
  },
  {
    key: 'punting_average',
    label: 'Punts (Average)',
    localized_label: messages.football.punting_average,
  },
  {
    key: 'penalty_yards',
    label: 'Penalties (Yards)',
    localized_label: messages.football.penalty_yards,
  },
  {
    key: 'fumbles_lost',
    label: 'Fumbles (Lost)',
    localized_label: messages.football.fumbles_lost,
  },
  {
    key: 'time_in_possession',
    label: 'Possession',
    localized_label: messages.football.possession,
  },
];

export default {
  nba_pregame: NBA_PREGAME,
  wnba_pregame: WNBA_PREGAME,
  nba: NBA,
  wnba: WNBA,
  ncaab: NBA,
  mlb_overview: MLB_OVERVIEW,
  mlb_pitching: MLB_PITCHING,
  mlb_batting: MLB_BATTING,
  soccer: SOCCER,
  nhl: NHL,
  nhl_pregame_offensive: NHL_PREGAME_OFFENSIVE,
  nhl_pregame_defensive: NHL_PREGAME_DEFENSIVE,
  nfl_pregame_offensive: NFL_PREGAME_OFFENSIVE,
  nfl_pregame_defensive: NFL_PREGAME_DEFENSIVE,
  nfl: NFL,
};
